export const getSchoolDistrictStringValue = (schoolDistrict: number) => {
  return schoolDistrict?.toString() ?? '';
};
